import React, { FunctionComponent } from 'react';
import { Source } from 'react-map-gl';


const TerrainLayer: FunctionComponent = () => (
  // <Source id="mapbox-raster-dem" type="raster-dem" tiles={["http://localhost:8000/{z}/{x}/{y}.png"]} minzoom={12} maxzoom={22} tileSize={256} scheme={"tms"}>
  <Source id="mapbox-raster-dem" type="raster-dem" url="mapbox://mapbox.mapbox-terrain-dem-v1" tileSize={512} />
);
export default TerrainLayer;
